import { render, staticRenderFns } from "./createClaimPartyModal.vue?vue&type=template&id=70b99fe0&scoped=true&"
import script from "./createClaimPartyModal.vue?vue&type=script&lang=js&"
export * from "./createClaimPartyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b99fe0",
  null
  
)

export default component.exports